import Authorization from './Authorization';
export { default as AuthorizationOverview } from "./AuthorizationOverview";
export { default as Administration } from "./Administration";
export { default as AdministrationForm } from "./Administration/AdministrationForm";
export { default as AdministrationView } from "./Administration/AdministrationView";
export default Authorization;
